import {Component, Input, OnInit} from '@angular/core';
import {BaseResultComponent} from '../../base-result/base-result.component';
import {PipeChartResult} from '@core/class/result/pipe-chart-result';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-welfare-pipe-chart',
  templateUrl: './welfare-pipe-chart.component.html',
  styleUrls: ['./welfare-pipe-chart.component.css']
})
export class WelfarePipeChartComponent extends BaseResultComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  pipeChartResult: PipeChartResult;

  @Input()
  computeOnInit: boolean;

  @Input()
  hide = false;

  @Input()
  useCardContainer: boolean;

  pipeView: any[] = [500, 400];

  /*colorScheme = {
    domain: ['#ffee00', '#ff0006', '#3094D1', '#42517F', '#22FF00']
  };*/

  // assets
  assetDataSource: any[] = [];
  showLegend: true;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  ngOnInit() {
    if (this.computeOnInit) {
      this.createChart();
    }
  }

  onResultImpl(): void {
    super.onResultImpl();
    this.createChart();
  }

  private createChart() {

    if (this.pipeChartResult) {

      // clear data source
      this.assetDataSource = [];

      const series = this.pipeChartResult.series;

      if (series) {

        // push objects
        series.forEach(value => {
          this.assetDataSource.push(value);
        });

        // refresh data source
        this.assetDataSource = [...this.assetDataSource];
      }
    }
  }
}
